<template>
  <div class="dashboard">
    <header class="dashboard__header">
      <div class="header__logo">
        <svg width="28" height="28" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="32" height="32" rx="8" fill="#1e293b"/>
          <path d="M8 10h10M8 16h7M8 22h10" stroke="white" stroke-width="2.2" stroke-linecap="round"/>
          <circle cx="23" cy="22" r="4" fill="white" fill-opacity="0.2" stroke="white" stroke-width="1.5"/>
          <path d="M21.5 22l1 1 2-2" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="logo-text">FormIQ</span>
      </div>
      <div class="header__user">
        <span class="user-name">👤 {{ authStore.currentUser?.name }}</span>
        <button
          v-if="authStore.hasRole('FormIQManager')"
          class="admin-link-btn"
          @click="goTo('/admin')"
        >
          ⚙️ Admin
        </button>
        <button
          v-if="authStore.hasRole('FormIQWorker')"
          class="admin-link-btn"
          @click="goTo('/caseworker/review')"
        >
          🧑‍💼 Fachbereich
        </button>
        <button class="logout-btn" @click="handleLogout">Abmelden</button>
      </div>
    </header>

    <main class="dashboard__main">
      <div class="dashboard__welcome">
        <h1>Willkommen, {{ authStore.currentUser?.name }}!</h1>
        <p>Wählen Sie einen Antrag, um die geführte Showcase-Erfahrung zu beginnen.</p>
      </div>

      <div class="dashboard__tiles">
        <!-- Tile A: Literature -->
        <div class="tile tile--a" @click="goTo('/application/literature')">
          <div class="tile__header">
            <div class="tile__icon">📚</div>
            <div class="tile__badges">
              <span class="badge badge--blue">FormIQ 1</span>
              <span class="badge badge--yellow">Vorschau – Stabilitätshinweis</span>
            </div>
          </div>
          <h2 class="tile__title">Förderantrag für<br />deutschsprachige Literatur</h2>
          <p class="tile__desc">
            Begleiten Sie einen geführten Antrag mit schrittweiser Chat-Assistenz.
            FormIQ 1 Chat Assist hilft Ihnen beim Ausfüllen des Formulars, erklärt
            Abschnitte und beantwortet Ihre Fragen in Echtzeit.
          </p>
          <div class="tile__features">
            <span>💬 Chat Assist</span>
            <span>🌐 DE / EN / TR</span>
            <span>📋 Mehrstufiges Formular</span>
          </div>
          <div class="tile__cta">
            Antrag starten
            <span>→</span>
          </div>
        </div>

        <!-- Tile B: Naturalization -->
        <div class="tile tile--b" @click="goTo('/application/naturalization')">
          <div class="tile__header">
            <div class="tile__icon">🏛️</div>
            <div class="tile__badges">
              <span class="badge badge--green">FormIQ 2</span>
              <span class="badge badge--blue">FormIQ 1</span>
            </div>
          </div>
          <h2 class="tile__title">Einbürgerungsantrag –<br />deutsche Staatsangehörigkeit</h2>
          <p class="tile__desc">
            Erleben Sie intelligenten Dokument-Upload mit automatischer Felderkennung.
            Laden Sie Ihre Vollmacht hoch und beobachten Sie, wie FormIQ 2 AutoFill
            Formularfelder sofort über mehrere Seiten hinweg befüllt.
          </p>
          <div class="tile__features">
            <span>📄 AutoFill</span>
            <span>💬 Chat-Assistenz</span>
            <span>🔵 Feld-Hervorhebung</span>
          </div>
          <div class="tile__cta">
            Antrag starten
            <span>→</span>
          </div>
        </div>

        <!-- Tile C: Tree protection -->
        <div class="tile tile--c" @click="goTo('/application/tree-protection')">
          <div class="tile__header">
            <div class="tile__icon">🌳</div>
            <div class="tile__badges">
              <span class="badge badge--green">FormIQ 3</span>
              <span class="badge badge--blue">FormIQ 1 + FormIQ 2</span>
              <span class="badge badge--blue">Kategorisierung</span>
            </div>
          </div>
          <h2 class="tile__title">Baumschutz –<br />Ausnahmegenehmigung beantragen</h2>
          <p class="tile__desc">
            Erleben Sie die automatische Dokumentkategorisierung. Laden Sie Antrag, Lageplan
            und Begründung hoch und beobachten Sie, wie FormIQ 3 jedes Dokument einer Kategorie
            zuordnet und die Vollständigkeit prüft.
          </p>
          <div class="tile__features">
            <span>📄 Dokument-Upload</span>
            <span>🏷️ Kategorisierung</span>
            <span>✅ Vollständigkeitsprüfung</span>
          </div>
          <div class="tile__cta">
            Antrag starten
            <span>→</span>
          </div>
        </div>

      </div>

      <div class="dashboard__notice">
        ⚠️ &nbsp;Dies ist eine Showcase-Umgebung. Es werden keine echten Antragsdaten verarbeitet oder gespeichert.
      </div>
    </main>
  </div>
</template>

<script>
import { useRouter } from 'vue-router';
import { authStore } from '../store/auth';

export default {
  name: 'DashboardPage',
  setup() {
    const router = useRouter();

    const goTo = (path) => router.push(path);

    const handleLogout = () => {
      authStore.logout();
      router.push('/');
    };

    return { authStore, goTo, handleLogout };
  },
};
</script>

<style scoped>
.dashboard {
  min-height: 100vh;
  background: #f0f2f8;
  display: flex;
  flex-direction: column;
}

.dashboard__header {
  background: #ffffff;
  border-bottom: 3px solid #c0121c;
  padding: 16px 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #0f172a;
}

.header__logo {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 20px;
  font-weight: 700;
}
.logo-text { color: #0f172a; }

.header__user {
  display: flex;
  align-items: center;
  gap: 16px;
}
.user-name {
  font-size: 14px;
  color: #475569;
}
.logout-btn {
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  color: #0f172a;
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 13px;
  cursor: pointer;
  transition: background 0.2s;
}
.logout-btn:hover { background: #e2e8f0; }
.admin-link-btn {
  background: #eef2ff;
  border: 1px solid #c7d2fe;
  color: #3730a3;
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.2s;
}
.admin-link-btn:hover { background: #e0e7ff; }

.dashboard__main {
  flex: 1;
  padding: 48px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  max-width: 1100px;
  margin: 0 auto;
  width: 100%;
}

.dashboard__welcome {
  text-align: center;
}
.dashboard__welcome h1 {
  font-size: 32px;
  font-weight: 800;
  color: #1a1a2e;
}
.dashboard__welcome p {
  font-size: 16px;
  color: #666;
  margin-top: 8px;
}

.dashboard__tiles {
  display: flex;
  gap: 28px;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
}

.tile {
  background: #fff;
  border-radius: 24px;
  padding: 36px 32px;
  flex: 1;
  min-width: 300px;
  max-width: 480px;
  display: flex;
  flex-direction: column;
  gap: 18px;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  box-shadow: 0 4px 20px rgba(0,0,0,0.07);
  border: 2px solid transparent;
}
.tile:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 40px rgba(0,0,0,0.13);
}
.tile--a:hover { border-color: #60a5fa; }
.tile--b:hover { border-color: #34d399; }
.tile--c:hover { border-color: #4ade80; }

.tile__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.tile__icon {
  font-size: 40px;
  line-height: 1;
}

.tile__badges {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
}

.badge {
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.badge--blue { background: #dbeafe; color: #1d4ed8; }
.badge--green { background: #d1fae5; color: #065f46; }
.badge--yellow { background: #fef3c7; color: #92400e; }

.tile__title {
  font-size: 20px;
  font-weight: 800;
  color: #1a1a2e;
  line-height: 1.3;
}

.tile__desc {
  font-size: 14px;
  color: #555;
  line-height: 1.65;
  flex: 1;
}

.tile__features {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
.tile__features span {
  background: #f3f4f6;
  padding: 5px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  color: #374151;
}

.tile__cta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 700;
  color: #fff0f0;
  margin-top: 4px;
}
.tile--a .tile__cta {
  background: linear-gradient(135deg, #1e293b, #334155);
}
.tile--b .tile__cta {
  background: linear-gradient(135deg, #059669, #34d399);
}
.tile--c .tile__cta {
  background: linear-gradient(135deg, #15803d, #4ade80);
}

.dashboard__notice {
  background: #fef9c3;
  border: 1px solid #fde68a;
  color: #92400e;
  padding: 12px 24px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 500;
  text-align: center;
  max-width: 640px;
}
</style>
